import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
// import Paper from '@material-ui/core/Paper';
// import Typography from '@material-ui/core/Typography';

// import MoneyFormat from './format/MoneyFormat.js';

// import moment from 'moment';

// import firebase from 'firebase/app';

// require("firebase/firestore");
// require("moment-duration-format");

const styles = theme => ({

});

class PassReportPage extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {

  }

  componentDidUpdate(prevProps, prevState) {
    // if ((prevState.date && !moment(prevState.date).isSame(this.state.date)) ||
        // (prevState.branchId !== this.state.branchId)) {
      // this.queryTodayTransaction();
      // this.queryTodayPassTransaction();
    // }
  }

  componentDidMount() {

  }

  render() {
    // const { classes } = this.props;
    return (
      <div>

      </div>
    );
  }
}

PassReportPage.propTypes = {
  classes: PropTypes.object.isRequired,
  date: PropTypes.instanceOf(Date).isRequired,
};

export default withStyles(styles)(PassReportPage);
